import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { AppContext } from '@/shared/context/context';
import signalRMessages from '@/redux/actions/signalRMessages';
import useNotification from '@/shared/hooks/UseNotification';
import useSocketEvent from '@/shared/hooks/useSocketEvent';

const useGlobalDebtorsBatchDoneMessage = () => {
  const { t } = useTranslation();
  const { sendNotification } = useNotification();
  const { currentTeamId } = useContext(AppContext);

  useSocketEvent(signalRMessages.DebtorsBatchDone, (...args: string[]) => {
    const [teamId, , batchId] = args;

    if (teamId !== currentTeamId) return;
    sendNotification({
      message: t('_globalMessages.debtorsBatchFinished'),
      onSuccessRoute: `/batch/${batchId}`,
      variant: 'success',
    });
  });
};

export default useGlobalDebtorsBatchDoneMessage;
